import React from 'react';
import {Link} from 'react-router-dom';

import { SubscribeForm } from './../reuse/form_subscription';
// import {FooterLink, FooterExtLink} from './base';
import {CopyrightFooter, CompanyComponent, OtherProductsComponent, ReachComponent} from './common';



export function LandingFooter(props){
  const is_mobile = window.innerWidth < 1200;
  return(
    <footer>
      <div  className="p-1 pb-3 bg-primary box-shadow text-black-9">
        <div className="row m-0">
          <div className="col-sm-5 px-0"><AboutComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-2 px-0"><CompanyComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-2 px-0"><OtherProductsComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-3 px-0"><ReachComponent is_mobile={is_mobile} /></div>
        </div>
      </div>
      <CopyrightFooter padding={5} />
    </footer>
  )
}


function AboutComponent(props){
  return (
    <div className="">
      <div className="m-1">        
        <div className="mt-5 mb-2 ">
          <Link to="/" className="navbar-brand text-spacing-2 pr-2 bg-white btn-rounded">
            <img style={{height: "40px"}} className="hero mx-2" src="/logo.svg" alt="logo svg" />
            <span className="text-black-2">Passive</span><span className="text-primary">Compound</span>
          </Link>  
        </div>
        <div className=" text-spacing-1 family-code text-black-1 m-2 p-2 ">
          <p className="">
            Start investmenting early, even in small amounts, and let the power of compounding show its magic.
          </p>
        </div>
        
      </div>

      {/* <hr className="highlight-white-4 "/> */}

      <div className="m-3">
        <SubscribeForm full_width={true} />
      </div>
    </div>
  )
}
